export const payment ={   
    data(){
        return{
            paymethod:'BANK2',
            
            //결제관련           
            payment:{
                CPID:'CTS16994',    //가맹점ID 페이조아에서 부여   
                PRODUCTTYPE:'1',    // 상품구분(1: 디지털, 2: 실물)        
                BILLTYPE:'1',       // 과금 유형(1: 일반)
                TAXFREECD:'00',     // 과세 비과세 여부(00: 과세, 01: 비과세, 02: 복합과세)    
                HOMEURL:'/payment/result',           
                methods:['CARD','mobile','vaccount','bank'],
                apiUrl:'https://apitest.payjoa.co.kr/pay/link',                       
            },
        }
    },
    computed:{
        paymentIdx(){
            return this.payment.methods.indexOf(this.paymethod); 
        },
        getPopSize(){
            return this.payment.popSize[this.paymentIdx];    
        },
        getApiUrl(){            
            if(this.getMode === 'PC')
            {
                return this.payment.apiUrl[this.paymentIdx];    
            }else{
                return this.payment.apiUrl_m[this.paymentIdx];       
            }              
        },
        getApiType(){            
            if(this.getMode === 'PC')
            {
                return 'P';    
            }else{
                return "M";       
            }              
        }
    },
    methods:{
        async callPayment(){
            if(this.authCheck() !==true)
            {
                return;
            }
            //계좌 이체, 무통장 입금은 기존 루틴
            if(this.paymethod === 'BANK2')
            {
                this.buyItem();
                return;
            }

            //결제 페이지 호출 하기전 디비 기록
            const formData = {
                PAYMETHOD : this.paymethod,
                TYPE: this.getApiType,
                CPID : this.payment.CPID,
                ORDERNO : this.user.id +'_' + this.getTimeStamp(),                
                PRODUCTTYPE : this.payment.PRODUCTTYPE,
                AMOUNT : this.getTotalPrice,
                PRODUCTNAME : this.item.title,
                PRODUCTCODE : this.item.id,
                USERID : this.user.id,
                USERNAME : this.user.name,
                RESERVEDINDEX1 : this.counter, // 아이템 구매 갯수

                TAXFREECD : this.payment.TAXFREECD,              
                HOMEURL : this.$store.state.serverPath + this.payment.HOMEURL
            }
            try {
                const response = await this.$store.dispatch("payment/paymentCall", formData)
                console.log(response); 
                if(response.status_code === '500')
                {
                    this.$flashMessage.show({
                        type: "error",
                        title: response.message,
                        message: response.message,
                    }); 
                }else{
                    this.Payment();
                }
                  
                           
            }catch(error){
                console.log(error);
               
            }
        },
        Payment(){   
            
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", this.payment.apiUrl);
            form.setAttribute("accept-charset", "euc-kr");
            form.setAttribute("target", "PAYJOA1");
            
            //필수----------------------------------------
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = "PAYMETHOD"; //결제수단
            input.value = this.paymethod;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "TYPE"; //결제수단
            input.value = this.getApiType;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "CPID"; //가맹점 ID
            input.value = this.payment.CPID;
            form.appendChild(input);
            
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "ORDERNO"; //주문번호
            input.value = this.user.id +'_'+this.getTimeStamp();
            form.appendChild(input);
            
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "PRODUCTTYPE";//상품구분(1: 디지털, 2: 실물)
            input.value = this.payment.PRODUCTTYPE;
            form.appendChild(input);           

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "TAXFREECD";//과세 비과세 여부 (00: 과세, 01: 비과세, 02: 복합과세)           
            input.value = this.payment.TAXFREECD;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "AMOUNT";//결제금액
            input.value = this.getTotalPrice;
            form.appendChild(input);
            
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "PRODUCTNAME";//상품명
            input.value = this.item.title;
            form.appendChild(input);

            //선택----------------------------------
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "USERID";//고객 ID
            input.value = this.user.id;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "USERNAME";//고객명
            input.value = this.user.name;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "PRODUCTCODE";//상품코드
            input.value = this.item.id;
            form.appendChild(input);

            input = document.createElement('input');
            input.type = 'hidden';
            input.name = "BILLTYPE";//상품코드
            input.value = this.payment.BILLTYPE;
            form.appendChild(input);

 
            document.body.appendChild(form);
            
            window.open("", "PAYJOA1", "width=468,height=750");
            form.submit();
            document.body.removeChild(form);        
          
        },
        getTimeStamp() {
            var d = new Date();
            var month = d.getMonth() + 1;
            var date = d.getDate();
            var hour = d.getHours();
            var minute = d.getMinutes();
            var second = d.getSeconds();
        
            month = (month < 10 ? "0" : "") + month;
            date = (date < 10 ? "0" : "") + date;
            hour = (hour < 10 ? "0" : "") + hour;
            minute = (minute < 10 ? "0" : "") + minute;
            second = (second < 10 ? "0" : "") + second;
        
            var s = d.getFullYear() + month + date + hour + minute + second;
        
            return s;
        },
           
        
    }

}